import React from 'react';

import {
  FaFacebookF,
  FaTwitter,
  FaInstagram,
  FaLinkedin,
} from 'react-icons/fa';

import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';

import logo from '../../Assets/img/logo.webp';
import './style.css';

const Footer = () => {
  const { t } = useTranslation();
  const location = useLocation();

  // Get current language from URL
  const getCurrentLanguage = () => {
    const pathSegments = location.pathname.split('/').filter(Boolean);
    const supportedLangs = ['pl', 'rus', 'ua', 'en'];
    return supportedLangs.includes(pathSegments[0]) ? pathSegments[0] : 'pl';
  };

  // Generate language-specific routes
  const getLocalizedRoute = (route) => {
    const currentLang = getCurrentLanguage();

    const routeMap = {
      pl: {
        '/': '/',
        '/o-nas': '/o-nas',
        '/oferty-pracy': '/oferty-pracy',
        '/dla-pracownika': '/dla-pracownika',
        '/dla-pracodawcy': '/dla-pracodawcy',
        '/nasz-zespol': '/nasz-zespol',
        '/partnerzy': '/partnerzy',
        '/kontakt': '/kontakt',
        '/polityka-prywatnosci': '/polityka-prywatnosci',
      },
      rus: {
        '/': '/rus',
        '/o-nas': '/rus/o-nas',
        '/oferty-pracy': '/rus/vakansii',
        '/dla-pracownika': '/rus/dla-sotrudnika',
        '/dla-pracodawcy': '/rus/dla-rabotodatelya',
        '/nasz-zespol': '/rus/nasha-komanda',
        '/partnerzy': '/rus/partnery',
        '/kontakt': '/rus/kontakt',
        '/polityka-prywatnosci': '/rus/politika-konfidencialnosti',
      },
      ua: {
        '/': '/ua',
        '/o-nas': '/ua/pro-nas',
        '/oferty-pracy': '/ua/vakansii',
        '/dla-pracownika': '/ua/dlya-pratsivnika',
        '/dla-pracodawcy': '/ua/dlya-robotodavtsya',
        '/nasz-zespol': '/ua/nasha-komanda',
        '/partnerzy': '/ua/partneri',
        '/kontakt': '/ua/kontakt',
        '/polityka-prywatnosci': '/ua/politika-konfidencinosti',
      },
      en: {
        '/': '/en',
        '/o-nas': '/en/about-us',
        '/oferty-pracy': '/en/job-offers',
        '/dla-pracownika': '/en/for-workers',
        '/dla-pracodawcy': '/en/for-employers',
        '/nasz-zespol': '/en/our-team',
        '/partnerzy': '/en/partners',
        '/kontakt': '/en/contact',
        '/polityka-prywatnosci': '/en/privacy-policy',
      },
    };

    return routeMap[currentLang][route] || route;
  };

  return (
    <footer className='Footer'>
      <div className='Footer__container'>
        <div className='Footer__content'>
          {/* Logo and company info */}
          <div className='Footer__brand'>
            <div className='Footer__logo'>
              <img
                src={logo}
                alt='OpusA.P.T Logo'
                className='Footer__logo-image'
              />
              <span className='Footer__logo-text'>
                Opus<span className='Footer__logo-accent'> HR</span>
              </span>
            </div>
            <p className='Footer__description'>{t('footer.description')}</p>
            <div className='Footer__social'>
              <a href='#' className='Footer__social-link' aria-label='Facebook'>
                <FaFacebookF />
              </a>
              <a href='#' className='Footer__social-link' aria-label='Twitter'>
                <FaTwitter />
              </a>
              <a
                href='#'
                className='Footer__social-link'
                aria-label='Instagram'
              >
                <FaInstagram />
              </a>
              <a href='#' className='Footer__social-link' aria-label='LinkedIn'>
                <FaLinkedin />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className='Footer__links'>
            <h4 className='Footer__links-title'>{t('navigation.home')}</h4>
            <ul className='Footer__links-list'>
              <li>
                <Link to={getLocalizedRoute('/o-nas')} className='Footer__link'>
                  {t('navigation.aboutUs')}
                </Link>
              </li>
              <li>
                <Link
                  to={getLocalizedRoute('/oferty-pracy')}
                  className='Footer__link'
                >
                  {t('navigation.vacancies')}
                </Link>
              </li>
              <li>
                <Link
                  to={getLocalizedRoute('/nasz-zespol')}
                  className='Footer__link'
                >
                  {t('navigation.ourTeam')}
                </Link>
              </li>
              <li>
                <Link
                  to={getLocalizedRoute('/partnerzy')}
                  className='Footer__link'
                >
                  {t('navigation.partners')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div className='Footer__links'>
            <h4 className='Footer__links-title'>
              {t('footer.services', 'Usługi')}
            </h4>
            <ul className='Footer__links-list'>
              <li>
                <Link
                  to={getLocalizedRoute('/dla-pracownika')}
                  className='Footer__link'
                >
                  {t('navigation.forWorkers')}
                </Link>
              </li>
              <li>
                <Link
                  to={getLocalizedRoute('/dla-pracodawcy')}
                  className='Footer__link'
                >
                  {t('navigation.forEmployers')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div className='Footer__contact'>
            <h4 className='Footer__contact-title'>{t('navigation.contact')}</h4>
            <div className='Footer__contact-info'>
              <p>ul. Chłodna 15a/7</p>
              <p>66-300 Międzyrzecz</p>
              <p>+48 531 865 066</p>
              <p>opus.apt2023@gmail.com</p>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className='Footer__bottom'>
          <div className='Footer__bottom-content'>
            <p className='Footer__copyright'>
              &copy; 2025 {t('footer.company')}. {t('footer.rights')}.
            </p>
            <div className='Footer__legal'>
              <Link
                to={getLocalizedRoute('/polityka-prywatnosci')}
                className='Footer__legal-link'
              >
                {t('footer.privacy')}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
